import { RichUtils } from "draft-js";
import { Stack, IconButton, Card } from "@mui/material";
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatSizeIcon from '@mui/icons-material/FormatSize';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

const Toolbar = ({ editorState, setEditorState }) => {
    const tools = [
        { label: "Negrita", style: "BOLD", icon: <FormatBoldIcon />, method: "inline" },
        { label: "Cursiva", style: "ITALIC", icon: <FormatItalicIcon />, method: "inline" },
        { label: "Subrayado", style: "UNDERLINE", icon: <FormatUnderlinedIcon />, method: "inline" },
        { label: "Resaltar", style: "HIGHLIGHT", icon: <AutoFixHighIcon />, method: "inline" },
        { label: "Lista ordenada", style: "ordered-list-item", method: "block", icon: <FormatListNumberedIcon /> },
        { label: "Lista con viñetas", style: "unordered-list-item", method: "block", icon: <FormatListBulletedIcon /> },
        { label: "Mayúscula", style: "UPPERCASE", icon: <FormatSizeIcon />, method: "inline" },
        { label: "Titulo", style: "header-one", method: "block" },
        { label: "Subtítulo", style: "header-two", method: "block" },
    ];

    const applyStyle = (e, style, method) => {
        e.preventDefault();
        method === "block"
        ? setEditorState(RichUtils.toggleBlockType(editorState, style))
        : setEditorState(RichUtils.toggleInlineStyle(editorState, style));
    };

    const isActive = (style, method) => {
        if (method === "block") {
        const selection = editorState.getSelection();
        const blockType = editorState
            .getCurrentContent()
            .getBlockForKey(selection.getStartKey())
            .getType();
        return blockType === style;
        } else {
        const currentStyle = editorState.getCurrentInlineStyle();
        return currentStyle.has(style);
        }
    };

    return (
        <Card sx={{mb: -0.5, boxShadow: "none" }}>
            <Stack direction="row">
            {tools.map((item, idx) => (
                <IconButton
                    style={{
                        fontSize: "1rem",
                        padding: "10px !important",
                        color: isActive(item.style, item.method) ? "rgba(0, 0, 0, 1)" : "rgba(0, 0, 0, 0.3)",
                    }}
                    key={`${item.label}-${idx}`}
                    title={item.label}
                    onClick={(e) => applyStyle(e, item.style, item.method)}
                    onMouseDown={(e) => e.preventDefault()}
                >
                {item.icon || item.label}
                </IconButton>
            ))}
            </Stack>
        </Card>
    );
};

export default Toolbar;